import { render, staticRenderFns } from "./DayScheduleItemsTable.vue?vue&type=template&id=0deffee5&"
import script from "./DayScheduleItemsTable.vue?vue&type=script&lang=js&"
export * from "./DayScheduleItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports